import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2216f08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-menu flex flex-column z-2" }
const _hoisted_2 = {
  key: 0,
  class: "side-menu-mobile",
  style: {"background-color":"#ffffff"}
}
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = {
  class: "p-2 no-mobile-hide",
  style: {"background-color":"#ffffff"}
}
const _hoisted_5 = { class: "layout-content p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenuLink = _resolveComponent("AppMenuLink")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AppMenuLink, { menuItems: _ctx.furnituresMenuItems }, null, 8, ["menuItems"])
    ]),
    (_ctx.showSideMenuMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_button, {
              buttonType: "main",
              buttonSize: "m",
              buttonText: "Catégories",
              onClick: _ctx.showMenuMobile,
              class: "w-full"
            }, null, 8, ["onClick"])
          ]),
          _createVNode(_component_AppMenuLink, {
            menuItems: _ctx.furnituresMenuItems,
            onClickedItem: _ctx.showMenuMobile
          }, null, 8, ["menuItems", "onClickedItem"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_app_button, {
        buttonType: "main",
        buttonSize: "m",
        buttonText: "Catégories",
        style: {"width":"100%"},
        onClick: _ctx.showMenuMobile
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}